<script>
import formatCurrency from "@utils/format-currency";
import { prepaidFormatExpiredDate, prepaidIsExpired } from "@utils/ipetbooking-prepaid";
import { memberApplicablePrepaidOptions } from "@utils/ipetbooking-options";
import { authComputed } from "@store/helpers";

export default {
  components: {
    DetailOrderItemDeposit: () => import("./Item/DetailOrderItemDeposit.Jtails"),
  },
  props: {
    orderItem: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    const checkApplicablePrepaid = () => {
      const memberApplicablePrepaidOpenOptions = memberApplicablePrepaidOptions({
        type: 'open'
      });

      if(!memberApplicablePrepaidOpenOptions[0] && this.isLoggedIn) {
        this.tryToFetchApplicablePrepaidOrderList()
      }
    };

    checkApplicablePrepaid();
  },
  methods: {
    formatCurrency,
    prepaidIsExpired,
    prepaidFormatExpiredDate,
    tryToFetchApplicablePrepaidOrderList() {
      this.$store.dispatch('order/fetchApplicablePrepaidOrderList')
    }
  },
}
</script>
<!-- section template -->
<template>
  <div :class="$style.detailOrderDeposit">
    <div>
      <div class="text-center mb-4">
        <div class="detailOrderDeposit__name mb-3">
          <span>{{ orderItem.orders.items[0].params[0].title }}</span>
        </div>
        <div class="detailOrderDeposit__meta">
          <!-- <div class="detailOrderDeposit__point font-number">{{ formatCurrency(orderItem.orders.items[0].point) }}點</div> -->
          <div>目前剩餘點數<span class="text-primary">{{ formatCurrency(currentMember.point) }}點</span></div>
        </div>
      </div>
    </div>
    <DetailOrderItemDeposit
      :order-item="orderItem"
    />
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.detailOrderDeposit {
  :global {
    .detailOrderDeposit {
      &__name {
        margin-bottom: 0.25rem;
        font-weight: 600;
        font-size: 1.5rem;
        color: $color-primary-dark;
      }

      &__meta {
        font-size: 0.875rem;
        color: $color-gray-2;
      }

      &__point {
        font-size: 3rem;
        letter-spacing: 2.4px;
        line-height: 4.5rem;
        color: $color-primary;
        font-weight: 700;
      }
    }
  }
}
</style>
